/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImageApiModel } from './image';
import { AccountsRecApiModel } from './accounts-rec';
import { CouponApiModel } from './coupon';
import { BonusesRecApiModel } from './bonuses-rec';
import { LoyaltyApiModel } from './loyalty';

export interface CustomerWalletItemApiModel {
  accounts?: Array<AccountsRecApiModel> | null;
  bonuses?: Array<BonusesRecApiModel> | null;
  coupons?: Array<CouponApiModel> | null;
  /**
   * Wallet item base description
   */
  description?: string | null;
  /**
   * Wallet item in favorites (for Loyalty only)
   */
  favorite?: boolean | null;
  /**
   * Wallet item base (business/Loyalty) ID
   */
  id?: string | null;
  /**
   * Loyalties (only for type is \'business\')
   */
  loyalties?: Array<LoyaltyApiModel> | null;
  /**
   * Logos
   */
  photos?: Array<ImageApiModel> | null;
  /**
   * Wallet item base title
   */
  title?: string | null;
  /**
   * Wallet item type
   */
  type?: CustomerWalletItemApiModelTypeEnum | null;
}
export enum CustomerWalletItemApiModelTypeEnum {
  Business = 'business',
  Loyalty = 'loyalty'
}
